import { Breakpoint, type SliderConfig } from '@jsmdg/yoshi';
import { PageType } from '../../../shared/enums/pageType';

type ConfigByPageType = {
    [key in PageType]?: SliderConfig;
};

const productSliderConfigHome: SliderConfig = {
    spaceBetween: 12,
    slidesPerView: 2,
    slidesPerGroup: 2,
    showPagination: true,
    showNavigation: true,
    breakpoints: {
        [Breakpoint.SM]: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 16 },
    },
};

const productSliderConfig: ConfigByPageType = {
    [PageType.Home]: productSliderConfigHome,
};

export { productSliderConfig };
